"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiTree = _interopRequireDefault(require("@tencent/spaui-tree"));

var _index = require("../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var isFunction = _spauiUtils.utils.isFunction,
    isArray = _spauiUtils.utils.isArray,
    looseIndexOf = _spauiUtils.utils.looseIndexOf;

var SelectionDataComponent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SelectionDataComponent, _PureComponent);

  function SelectionDataComponent(props) {
    var _this;

    _classCallCheck(this, SelectionDataComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectionDataComponent).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.state = {
      expandNodeIds: typeof props.expandNodeIds !== 'undefined' ? props.expandNodeIds : _spauiUtils.nodeTree.getExpandIds(props.data, props.value)
    }; // 内部临时展开的expandNodeIds

    _this.tmpExpandNodeIds = null;
    return _this;
  }

  _createClass(SelectionDataComponent, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var expandValue = this.state.expandNodeIds;
      var tmpExpandNodeIds = this.tmpExpandNodeIds;
      var diffValue = [];
      var thisValue = this.props.value;
      var nextValue = nextProps.value;
      var isUpdateExpandNodeIds = true;

      if (typeof nextProps.expandNodeIds !== 'undefined') {
        this.setState({
          expandNodeIds: nextProps.expandNodeIds
        });
      } else {
        // 如果差别的数据，在扩展数据里面有，就不进行展开了
        if (isArray(thisValue) && isArray(nextValue) && nextValue.length !== thisValue.length) {
          nextValue.map(function (item) {
            if (looseIndexOf(thisValue, item) < 0) {
              diffValue.push(item);
            }

            return item;
          });
          thisValue.map(function (item) {
            if (looseIndexOf(nextValue, item) < 0) {
              diffValue.push(item);
            }

            return item;
          });
          diffValue.map(function (item) {
            if (looseIndexOf(tmpExpandNodeIds || expandValue, item) > -1) {
              isUpdateExpandNodeIds = false;
            }

            return item;
          });
        }

        if (!(0, _index.isEqualArray)(nextProps.value, this.props.value) && isUpdateExpandNodeIds) {
          if (isArray(nextProps.value)) {
            expandValue = [nextProps.value[nextProps.value.length - 1]];
          } else {
            expandValue = nextProps.value;
          }

          this.setState({
            expandNodeIds: _spauiUtils.nodeTree.getExpandIds(nextProps.data, expandValue)
          });
        }
      }

      this.tmpExpandNodeIds = null;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event, checkedIds, treeNode) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          multiple = _this$props.multiple,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? [] : _this$props$value;
      var result = '';

      if (multiple) {
        result = checkedIds;
      } else {
        if (isArray(value)) {
          if (looseIndexOf(value, treeNode.value) > -1) {
            result = [];
          } else {
            result = [treeNode.value];
          }
        } else {
          if (value === treeNode.value) {
            result = [];
          } else {
            result = [treeNode.value];
          }
        }
      }

      if (isFunction(onChange)) {
        onChange(event, result, true, treeNode);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event, expandNodeIds, treeNode, valueNodeMap) {
      var onNodeClick = this.props.onNodeClick;
      this.tmpExpandNodeIds = null;

      if (typeof this.props.expandNodeIds === 'undefined') {
        // 因为onChange跟onClick是并行的，如果使用内部的expandNodesIds判断，在重新接受参数时可能会出现这里的setState还没执行完
        this.tmpExpandNodeIds = [].concat(expandNodeIds);
        this.setState({
          expandNodeIds: [].concat(expandNodeIds)
        });
      }

      if (isFunction(onNodeClick)) {
        onNodeClick(event, expandNodeIds, treeNode, valueNodeMap);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          value = _this$props2.value,
          TreeProps = _this$props2.TreeProps,
          disabled = _this$props2.disabled,
          valueType = _this$props2.valueType,
          unrelated = _this$props2.unrelated,
          selectTarget = _this$props2.selectTarget,
          canSelected = _this$props2.canSelected,
          onColumnScroll = _this$props2.onColumnScroll,
          loadingIds = _this$props2.loadingIds,
          open = _this$props2.open,
          fieldNames = _this$props2.fieldNames,
          _this$props2$multiple = _this$props2.multiple,
          multiple = _this$props2$multiple === void 0 ? true : _this$props2$multiple,
          isAutoCheckedParent = _this$props2.isAutoCheckedParent,
          setNodeClassName = _this$props2.setNodeClassName,
          setBranchTitle = _this$props2.setBranchTitle,
          _this$props2$branchTi = _this$props2.branchTitleClassName,
          branchTitleClassName = _this$props2$branchTi === void 0 ? '' : _this$props2$branchTi;
      var expandNodeIds = this.state.expandNodeIds;

      if (!open) {
        return null;
      }

      return _react["default"].createElement(_spauiTree["default"], _extends({
        data: data,
        value: value,
        valueType: valueType,
        unrelated: unrelated,
        isAutoCheckedParent: isAutoCheckedParent,
        setNodeClassName: setNodeClassName,
        setBranchTitle: setBranchTitle,
        branchTitleClassName: branchTitleClassName,
        selectTarget: selectTarget,
        expandNodeIds: expandNodeIds,
        onChange: this.handleChange,
        onClick: this.handleClick,
        canSelected: canSelected,
        onColumnScroll: onColumnScroll,
        loadingIds: loadingIds,
        fieldNames: fieldNames
      }, TreeProps, {
        multiple: multiple,
        disabled: disabled
      }));
    }
  }]);

  return SelectionDataComponent;
}(_react.PureComponent);

var _default = SelectionDataComponent;
exports["default"] = _default;